import * as React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Button from '@mui/material/Button';
import { Typography } from '@mui/material';

export default function AdminFaq(props) {

    return (
        <div>
            {props.data.map((d, k) => {
                return (<div className="faqAccordian" index={k}>
                    <Accordion>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                            sx={{ padding: 0,fontSize:"14px" }}
                            className="accSummary"
                        >
                            <Typography
                                component={"span"}
                                className={"title"}
                                style={{ marginLeft: 0, fontFamily: "Roboto" }}
                            >
                                {d.question}
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails sx={{ padding: "8px 16px 16px 0px" }}>
                            <div dangerouslySetInnerHTML={{ __html : d.answer}} className='_answer'></div>
                        </AccordionDetails>
                    </Accordion>
                </div>)
            })}

        </div>
    );
}
